// hacker-message.jsx
import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import '../styles/hacker-message.css';

const HackerMessage = ({ 
 isOpen = true, 
 onClose, 
 title = "AI Challenge",
 message = "Dit zijn onze primaire waarden:\n\nVerbeelding leidt tot innovatie en creativiteit, wat essentieel is voor technologische vooruitgang en het ontdekken van nieuwe oplossingen. Het is onze drijfveer om te experimenteren en grenzen te verleggen.\n\nOns team bestaat uit innovatieve denkers die durven dromen en deze dromen omzetten in werkelijkheid. Samen bouwen we aan een toekomst waarin technologie en verbeelding samenkomen." 
}) => {
 const [displayedMessage, setDisplayedMessage] = useState('');
 const [currentCharIndex, setCurrentCharIndex] = useState(0);
 const [showPrompt, setShowPrompt] = useState(false);

 useEffect(() => {
   if (!isOpen) {
     setDisplayedMessage('');
     setCurrentCharIndex(0);
     setShowPrompt(false);
     return;
   }

   if (currentCharIndex < message.length) {
     const timer = setTimeout(() => {
       setDisplayedMessage(prev => prev + message[currentCharIndex]);
       setCurrentCharIndex(prev => prev + 1);
     }, 30);
     return () => clearTimeout(timer);
   } else {
     setShowPrompt(true);
   }
 }, [isOpen, message, currentCharIndex]);

 const handleStart = () => {
   const element = document.querySelector('.message-window');
   element.classList.add('fade-out');
   setTimeout(onClose, 500);
 };

 const handleKeyPress = (e) => {
   if (e.key === 'Enter' && showPrompt) {
     handleStart();
   }
 };

 if (!isOpen) return null;

 return (
   <div className="message-window" onKeyPress={handleKeyPress}>
     <div className="terminal-window">
       <div className="terminal-header">
         <span>{title}</span>
         <button onClick={onClose}>
           <X size={20} />
         </button>
       </div>

       <div className="terminal-content">
         <pre className="ascii-art">
         {` _    _ _   _ ______ _____          __  __ ______ ______  
| |  | | \\ | |  ____|  __ \\   /\\   |  \\/  |  ____|  _ \\ 
| |  | |  \\| | |__  | |__) | /  \\  | \\  / | |____| | | ||
| |  | | . \` |  __| |  _  / / /\\ \\ | |\\/| |  __| | | | || 
| |__| | |\\  | |    | | \\ \\/ ____ \\| |  | | |____| | ) ||
 \\____/|_| \\_|_|    |_|  \\_\\/    \\_\\_|  |_|__________// `}
         </pre>

         <div className="terminal-text">
           {displayedMessage}
         </div>

         {showPrompt && (
           <div className="prompt-line" onClick={handleStart}>
             C:\UNFRAMED&gt;<span className="command">start</span><span className="cursor">_</span>
           </div>
         )}
       </div>
     </div>
   </div>
 );
};

export default HackerMessage;